import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as BurgerIconOpen } from '../../assets/svg/burgerIconOpen.svg';
import { ReactComponent as BurgerIconClose } from '../../assets/svg/burgerIconClose.svg';

function ResponsiveMenu() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const scrollToSection = (sectionId) => {
        setIsOpen(false);
        setTimeout(() => {
            window.scrollTo({top: document.querySelector(sectionId).offsetTop, behavior: "smooth"});
        }, 300); // adjust delay to match your CSS transition time
    };

  return (
    <div className="responsive-menu">
      <div className="burger-icon blue" onClick={toggleMenu}>
        {isOpen ? <BurgerIconClose /> : <BurgerIconOpen />}
      </div>

      <div className={isOpen ? 'responsive-menu-container open' : 'responsive-menu-container'}>
        <ul className="ta-center">
            <li><a href="true" rel="noopener" className="blue" onClick = {(e)=>{e.preventDefault(); scrollToSection("#dealer-section");}}>Πωλήσεις</a></li>
            <li><a href="true" rel="noopener" className="blue" onClick = {(e)=>{e.preventDefault(); scrollToSection("#service-section");}}>Service</a></li>
            <li><a href="true" rel="noopener" className="blue" onClick = {(e)=>{e.preventDefault(); scrollToSection("#dealer-info-section");}}>Εταιρία</a></li>
            <li><a href="true" rel="noopener" className="blue" onClick = {(e)=>{e.preventDefault(); scrollToSection("#configurator-section");}}>Διαμορφωτής</a></li>
            <li><a href="true" rel="noopener" className="blue" onClick = {(e)=>{e.preventDefault(); scrollToSection("#model-section");}}>Μοντέλα</a></li>
            <li><a href="true" rel="noopener" className="blue" onClick = {(e)=>{e.preventDefault(); scrollToSection("#used-cars-section");}}>Μεταχειρισμένα</a></li>
            <li><a href="true" rel="noopener" className="blue" onClick = {(e)=>{e.preventDefault(); scrollToSection("#posts-section");}}>Νέα</a></li>
            <li><a href="true" rel="noopener" className="blue" onClick = {(e)=>{e.preventDefault(); scrollToSection("#contact-section");}}>Επικοινωνία</a></li>
        </ul>
      </div>

    </div>
  );
}

export default ResponsiveMenu;
